import { BaseClient } from '../BaseClient';
import { IDInt32 } from '../compiled-protos/common';
import {
  NoteTranslation,
  NoteTranslationList,
} from '../compiled-protos/s3';
import { S3ServiceClient } from '../compiled-protos/s3.client';

class NoteTranslationClient extends BaseClient {
  self: S3ServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new S3ServiceClient(this.transport);
  }

  public async Create(req: NoteTranslation): Promise<NoteTranslation> {
    const res = await this.self.createNoteTranslation(req, this.getMetaData()).response;
    return res;
  }

  public async Get(req: NoteTranslation): Promise<NoteTranslation | undefined> {
    try {
      const res = await this.self.getNoteTranslation(req, this.getMetaData()).response;
      return res;
    } catch (err) {
      console.error('NoteTranslationClient.Get error:', err);
      return undefined;
    }
  }

  public async BatchGet(req: NoteTranslation): Promise<NoteTranslationList> {
    const res = await this.self.batchGetNoteTranslation(req, this.getMetaData()).response;
    return res;
  }

  public async Update(req: NoteTranslation): Promise<NoteTranslation | undefined> {
    try {
      const res = await this.self.updateNoteTranslation(req, this.getMetaData()).response;
      return res;
    } catch (err) {
      console.error('NoteTranslationClient.Update error:', err);
      return undefined;
    }
  }

  public async Delete(id: number): Promise<void> {
    try {
      await this.self.deleteNoteTranslation(
        IDInt32.create({ id }),
        this.getMetaData(),
      ).response;
    } catch (err) {
      console.error('NoteTranslationClient.Delete error:', err);
    }
  }
}

export {
  NoteTranslation,
  NoteTranslationClient,
  NoteTranslationList,
};
